// base url
if (location.hostname == 'localhost' || location.hostname == 'localhost:8888') {
    var path = '/pv/';
} else {
    var path = '/';
}

// document.addEventListener('touchstart', onTouchStart, {passive: true});


var token = $('html').attr('token');
var lang = $('html').attr('lang');

// personnalise les datas à transmettre en dehors d'un serializeArray() dans la fonction xhr_send()
function xhr_data(file, data, $this) {
	switch(file) {
		case 'formation/search-training':
			var filter = [];
			var cat = [];
			var search = $('#search-training').val();
			var page = $('#paginations .page-item.active').attr('id');
			if (page === undefined) {
				page = 1;
			}

			$('input[data-search-cat]:checked').each(function(i) {
	            filter.push($(this).val());
	            cat.push($(this).data('search-cat'));
	    	});

	    	var range = '1;Cycle';
	    	var duree = '1;Cycle';

	    	data[data.length] = { name: 'filter[]', value: filter };
	    	data[data.length] = { name: 'cat[]', value: cat };
	    	data[data.length] = { name: 'search', value: search };
	    	data[data.length] = { name: 'page', value: page };
	    	data[data.length] = { name: 'range', value: range };
	    	data[data.length] = { name: 'duree', value: duree };
	    	break;
	    /*case 'simulator/contact':

			var address = localStorage.getItem('simulator_address');
			var roof = localStorage.getItem('simulator_roof');
			var map = localStorage.getItem('simulator_map');
			var area = localStorage.getItem('simulator_area');
			var conso = localStorage.getItem('simulator_conso');
			var orientation = localStorage.getItem('simulator_orientation');

	    	data[data.length] = { name: 'address', value: address };
	    	data[data.length] = { name: 'roof', value: roof };
	    	data[data.length] = { name: 'map', value: map };
	    	data[data.length] = { name: 'area', value: area };
	    	data[data.length] = { name: 'conso', value: conso };
	    	data[data.length] = { name: 'orientation', value: orientation };
	    	break;*/


	    case 'simulator/contact':

			var address = localStorage.getItem('simulator_address');
			var roof = localStorage.getItem('simulator_roof');
			var map = localStorage.getItem('simulator_map');
			var area = localStorage.getItem('simulator_area');
			var conso = localStorage.getItem('simulator_conso');
			var battery = localStorage.getItem('simulator_battery');
			var charger = localStorage.getItem('simulator_charger');
			var orientation = localStorage.getItem('simulator_orientation');

	    	data[data.length] = { name: 'address', value: address };
	    	data[data.length] = { name: 'roof', value: roof };
	    	data[data.length] = { name: 'map', value: map };
	    	data[data.length] = { name: 'area', value: area };
	    	data[data.length] = { name: 'conso', value: conso };
	    	data[data.length] = { name: 'battery', value: battery };
	    	data[data.length] = { name: 'charger', value: charger };
	    	data[data.length] = { name: 'orientation', value: orientation };
	    	break




	    case 'simulator/simulation':

			var address = localStorage.getItem('simulator_address');
			var roof = localStorage.getItem('simulator_roof');
			var map = localStorage.getItem('simulator_map');
			var area = localStorage.getItem('simulator_area');
			var conso = localStorage.getItem('simulator_conso');
			var battery = localStorage.getItem('simulator_battery');
			var charger = localStorage.getItem('simulator_charger');
			var orientation = localStorage.getItem('simulator_orientation');

	    	data[data.length] = { name: 'address', value: address };
	    	data[data.length] = { name: 'roof', value: roof };
	    	data[data.length] = { name: 'map', value: map };
	    	data[data.length] = { name: 'area', value: area };
	    	data[data.length] = { name: 'conso', value: conso };
	    	data[data.length] = { name: 'battery', value: battery };
	    	data[data.length] = { name: 'charger', value: charger };
	    	data[data.length] = { name: 'orientation', value: orientation };
	    	break

    	case 'contact/form':
			// Replace app token with front token
			for (var i = 0; i < data.length; i++) {
				if (data[i].name === 'token') {
					data[i].value = $('html').attr('front-token');
					break;
				}
			}
			break;

    	case 'commission/check-vat' :
			$this.closest('form').find('#vatHelp span').addClass('d-none');
			$this.closest('form').find('#vatHelp span.loading-text').removeClass('d-none');
			break;

	    default:
	    	return true;
    }
}

// personnalise les callback en cas de succès dans la fonction xhr_send()
function xhr_success(callback = null, response, data, path, $this) {
	var dataObj = {};
	for (i = 0; i < data.length; i++) {
		dataObj[data[i].name] = data[i].value;
	}

	switch(callback) {
    	case  'contact/contact':
			$('#contact-form').load(path+'Connections/request/xhr/contact/contact-success.php?pv='+response.pv);			
	    	break;

    	case  'borne/contact':
			$('#contact-form').load(path+'Connections/request/xhr/borne/contact-success.php');			
	    	break;

    	case  'battery/contact':
			$('#contact-form').load(path+'Connections/request/xhr/battery/contact-success.php');			
	    	break;

		case  'contact/contact':
			$('#newletter-form').load(path+'Connections/request/xhr/newsletter/success.php');
	    	break;

    	case  'webinaire/inscription':
			$('#contact-form').load(path+'Connections/request/xhr/webinaire/inscription-success.php');			
	    	break;

	    /*case 'simulator/contact':
	    	localStorage.removeItem('simulator_address');
		    localStorage.removeItem('simulator_map');
	    	localStorage.removeItem('simulator_area');
	    	localStorage.removeItem('simulator_orientation');
	    	localStorage.removeItem('simulator_roof');
	    	localStorage.removeItem('simulator_conso');
	    	// localStorage.removeItem('simulator_battery');
	    	// localStorage.removeItem('simulator_charger');
	    	break;

	    case  'simulator/phone':
			$('#phone-contact-box').load(path+'Connections/request/xhr/simulator/phone-success.php');
	    	break;*/

	    case 'simulator/contact':
	    	localStorage.removeItem('simulator_address');
		    localStorage.removeItem('simulator_map');
	    	localStorage.removeItem('simulator_area');
	    	localStorage.removeItem('simulator_orientation');
	    	localStorage.removeItem('simulator_roof');
	    	localStorage.removeItem('simulator_conso');
	    	localStorage.removeItem('simulator_battery');
	    	localStorage.removeItem('simulator_charger');
	    	break;

	    case 'simulator/simulation':

	    	const numberFormatter = new Intl.NumberFormat('de-DE', {
			  style: 'decimal',
			  minimumFractionDigits: 0,
			  maximumFractionDigits: 0
			});

			const numberFormatterCurrency = new Intl.NumberFormat('de-DE', {
			  style: 'currency',
			  currency: 'EUR'
			});

	    	$('#profitability').html(numberFormatter.format(response.report.profitability));
	    	$('#production').html(numberFormatter.format(response.report.production));
	    	$('#trees').html(numberFormatter.format(response.report.trees));
	    	$('#gain').html(numberFormatterCurrency.format(response.report.gain));
	    	$('#gain-year').html(numberFormatterCurrency.format(response.report.gain/25));
	    	$('#gain-month').html(numberFormatterCurrency.format(response.report.gain/25/12));
	    	break;

	    case  'simulator/phone':
			$('#phone-contact-box').load(path+'Connections/request/xhr/simulator/phone-success.php');
	    	break;

	    case 'commission/check-vat' :
			$.each(response.json_formated, function( index, value ) {
				if(index != 'id_keyword' && index != 'token') {
					$('#'+index).val(value);
				}					
			});
			$this.closest('form').find('#vatHelp span').removeClass('d-none');
			$this.closest('form').find('#vatHelp span.loading-text').addClass('d-none');

			break;
			
		case  'commission/inscription':
			$('#contact-form').load(path+'Connections/request/xhr/commission/inscription-success.php');			
	    	break;

	    case 'contact/form':
	    	$('#contact-form').html(
	    		'<div class="oe-form-success" role="alert">' +
	    			'<div class="oe-form-success__icon"><i class="fa-solid fa-circle-check" aria-hidden="true"></i></div>' +
	    			'<h2 class="oe-form-success__title">Message envoyé !</h2>' +
	    			'<p class="oe-form-success__text">Merci pour votre message. Nous vous répondrons dans les 24 heures (jours ouvrables).</p>' +
	    		'</div>'
	    	);
	    	break;

	    default:
	    	return true;
	}
}

// ============================================================
// Oak Eye — Navbar scroll behavior
// ============================================================
$(window).on('scroll.oeNavbar', function() {
	var scrolled = $(this).scrollTop() > 60;
	$('.oe-navbar').toggleClass('scrolled', scrolled);
});
// Init on load (in case page is refreshed mid-scroll)
if ($(window).scrollTop() > 60) {
	$('.oe-navbar').addClass('scrolled');
}

// ============================================================
// Oak Eye — Smooth scroll for anchor links
// ============================================================
$(document).on('click', 'a[href^="#"]', function(e) {
	var target = $(this).attr('href');
	if (target.length > 1 && $(target).length) {
		e.preventDefault();
		var offset = parseInt($('.oe-navbar').outerHeight() || 80, 10) + 16;
		$('html, body').animate({ scrollTop: $(target).offset().top - offset }, 400);
	}
});

// fonction principale pour l'envoie et le controle de requêtes ajax
function xhr_send(path, token, $this) {
	var file = $this.data('xhr');
	if($this.data('type') !== undefined) {
		var type = $this.data('type');
	}
	else {
		var type = null;
	}
	var form = '#'+$this.closest('form').attr('id');

	if(type == 'delete') {
		var id = $this.closest('[data-id]').data('id');

		if(confirm('Voulez-vous supprimer cette ligne ?')) {
			$.post(path+'administration/request/xhr/'+file+'.php', { id: id, token: token }, function(response, statusText, jqXHR) {
				if(response.action == 'success') {

					if(response.callback === true) {
						xhr_success(file, response, data, path, $this);
					}
					else {
						if(response.msg != null) {
							// toastr.success(response.msg);
						}
						$this.closest('[data-id]').remove()					
					}

					if(response.url != null) {
						location.href = response.url;
					}
				}
				else if(response.action == 'empty') {
					if(response.msg != null) {
						// toastr.warning(response.msg);
					}
				}
				else if(response.action == 'recaptcha') {
					if(response.msg != null) {
						// toastr.warning(response.msg);
					}
					recaptcha();
				}
				else if(response.action == 'token') {
					location.reload();
				}   
				else {
					if(response.msg != null) {
						// toastr.error(response.msg);
					}
					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', debug:true, token: token}, function(response2) {}, 'json');
				}
			}, 'json')
			.always(function(jqXHR) {
			    if(jqXHR.status == 404) {			    	
					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
			    }
			    else if(jqXHR.status == 500) {			    	
					// toastr.error('Request error. Please contact the support');

					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
			    }
			});
		}
	}
	else {
		var data = $(form).serializeArray();
		data[data.length] = { name: 'token', value: token };

		$('.tinymce').each(function() {
			var currentEditorId = $(this).attr('id');
			var val = tinyMCE.get($(this).attr('id')).getContent();

			for (index = 0; index < data.length; ++index) {
			    if (data[index].name == currentEditorId) {
			        data[index].value = val;
			    }
			}
		});

		xhr_data(file, data, $this);

		$('.input__field--error').removeClass('input__field--error');
		$.post(path+'Connections/request/xhr/'+file+'.php', data, function(response, statusText, jqXHR) {
			if(response.action == 'success') {
				if(response.callback === true) {
					xhr_success(file, response, data, path, $this);
				}
				else {
					if(response.msg != null) {
						// toastr.success(response.msg);						
					}
				}

				if(response.url != null) {
					location.href = response.url;
				}
			}
			else if(response.action == 'empty') {
				if(response.msg != null) {
					// toastr.warning(response.msg);
				}

				$.each(response.fields, function(i, item) {
				    $(form).find('#'+item).addClass('input__field--error');
				});
			}
			else if(response.action == 'recaptcha') {
				if(response.msg != null) {
					// toastr.warning(response.msg);
				}
				recaptcha();
			}
			else if(response.action == 'token') {
				location.reload();
			}
			else {
				if(response.msg != null) {
					// toastr.error(response.msg);
				}

				$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', debug:true, token: token}, function(response2) {}, 'json');
			}
		}, 'json')
		.always(function(jqXHR) {
		    if(jqXHR.status == 404) {			    	
				$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
		    }
		    else if(jqXHR.status == 500) {			    	
				// toastr.error('Request error. Please contact the support');

				$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
		    }
		});
	}
}

$(document).ready(function() {

	function keywords(keyword) {
		/*var import_data = $.ajax({ type: 'GET',   
                        url: path+'data.json',   
                        async: true
                      }).responseText;
		var define = JSON.parse(import_data)[0];

		return define.keys.keyword;*/

		var output = $.getJSON(path+'app/dist/assets/js/data.php', function(response) {
			// var define = JSON.parse(response);
			return response.keys.GOOGLE_RECAPTCHA_KEY;

		});

		return output;

	}
    var data_table_i18n = { 'fr': 'French', 'en' : 'English', 'nl' : 'Dutch'};

    /*toastr.options = {
		"closeButton": true,
		"debug": false,
		"newestOnTop": false,
		"progressBar": true,
		"positionClass": "toast-top-center",
		"preventDuplicates": true,
		"onclick": null,
		"showDuration": "300",
		"hideDuration": "1000",
		"timeOut": "2000",
		"extendedTimeOut": "1000",
		"showEasing": "swing",
		"hideEasing": "linear",
		"showMethod": "fadeIn",
		"hideMethod": "fadeOut"
	}*/

	// init datatable
	if($('body').find('.data-table').length>0) {
		//var language = $('html').attr('lang');
        $('.data-table').DataTable({
            responsive: true,
            fixedHeader: {
                header: false,
                footer: true
            },
            "language": {
                "url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/"+data_table_i18n[lang]+".json"
            },
            "pageLength": 25,
            "aaSorting": []
        });

		$.fn.dataTable.moment = function ( format, locale ) {
		    var types = $.fn.dataTable.ext.type;
		 
		    // Add type detection
		    types.detect.unshift( function ( d ) {
		        return moment( d, format, locale, true ).isValid() ?
		            'moment-'+format :
		            null;
		    } );
		 
		    // Add sorting method - use an integer for the sorting
		    types.order[ 'moment-'+format+'-pre' ] = function ( d ) {
		        return moment( d, format, locale, true ).unix();
		    };
		};

		$.fn.dataTable.moment( 'DD-MM-YYYY' );
	}

	// init datepicker
	if($('.datepicker').length > 0) {
		$('.datepicker').datepicker({
		    format: "dd-mm-yyyy",
		    weekStart: 1,
		    daysOfWeekDisabled: "0,6",
	    	startDate: '0d'
		});
	}
	
	// init flash
	if($('#modal-flash').length > 0) {
		var flash = $('#modal-flash').data('flash');

		if(localStorage.getItem('flash') === null || localStorage.getItem('flash') != flash) {			
			$('#modal-flash').modal('show');
			localStorage.clear();
		}

		$(document).on('click', '#modal-flash .btn-close', function() {
			localStorage.setItem('flash', flash);
		});

	}

	function recaptcha()
	{
		 grecaptcha.ready(function() {
			grecaptcha.execute(keywords('GOOGLE_RECAPTCHA_KEY'), {action: 'send_form'})
			.then(function(token) {
				var recaptchaResponse = document.getElementById('g-recaptcha-response');
            	recaptchaResponse.value = token;
				
			})
		});
	}

    if($('#g-recaptcha-response').length > 0) {
    	recaptcha();
    	
		var intervalID = setInterval(recaptcha, 110*1000);
    }

	

	// bind un click sur les éléments portant le [data-xhr]
	$(document).on('click', '[data-xhr]', function(e) {
		e.preventDefault();
		var $this = $(this);

		xhr_send(path, token, $this);
	});

	// bind un click sur les éléments portant le [data-xhr]
	if($('#form-simulator #contact').length > 0) {
		var $this = $('#contact');
		xhr_send(path, token, $this);
	}

	// init mask
	Inputmask("BE 9999.999.999", {
	    "numericInput": true
	}).mask(".vat");

	$(document).on('change', '#vat', function(e) {
		var $this = $(this);

		xhr_send(path, token, $this);
	});
	// simulator

	/*if($('#form-simulator').length > 0) {
		// addresse

		if($('#form-simulator #full-address').length > 0) {
			// init 

			if (localStorage.getItem('simulator_address') !== null) {
				var simulator_address = JSON.parse(localStorage.getItem('simulator_address'));

				$('#form-simulator #full-address').val(simulator_address.location);
			}

			$(document).on('click', '#form-simulator .btn.btn-primary', function(e) {
				var simulator_address = JSON.parse(localStorage.getItem('simulator_address'));

				var check = false;
				for (var i in simulator_address.address) {
					var component = simulator_address.address[i];
					
					
					if(component.types[0] == 'street_number') {
						check = true;
					}
				}

				if(check == false) {
					e.preventDefault();
					$('#error-msg').html('Veuillez indiquer un numéro de rue');
					$('#error-msg').removeClass('d-none');				
					$('#full-address').addClass('input__field--error');
				}
			})
		}

		// roof
		if($('#simulator-roof').length > 0) {
			// init 
			if (localStorage.getItem('simulator_address') == null) {
				location.href = '/fr/simulateur';
			}

			if (localStorage.getItem('simulator_roof') !== null) {
				var simulator_roof = JSON.parse(localStorage.getItem('simulator_roof'));

				var src = $('#form-simulator .illu img').attr('src');

				$('#form-simulator .illu img').attr('src', src.replace(/(0|15|30|45)/, simulator_roof.roof));

				$('#simulator-roof .btn').removeClass('active');
				$('#simulator-roof .btn[id='+simulator_roof.roof+']').addClass('active');
			}

			// roof
			$(document).on('click', '#simulator-roof .btn', function(e) {
				var inclinaison = $(this).attr('id');

				var src = $('#form-simulator .illu img').attr('src');

				$('#simulator-roof .btn').removeClass('active');
				$(this).addClass('active');

				$('#form-simulator .illu img').attr('src', src.replace(/(0|15|30|45)/, inclinaison));
				
				const roof = {
				    roof: inclinaison
				}

				localStorage.setItem('simulator_roof', JSON.stringify(roof));
			});

			$(document).on('click', '#form-simulator .btn.btn-primary', function(e) {
				var inclinaison = $('#simulator-roof .active').attr('id');
				const roof = {
				    roof: inclinaison
				}

				localStorage.setItem('simulator_roof', JSON.stringify(roof));
			})
		}

		// orientation
		if($('#simulator-orientation').length > 0) {

			// init 
			if (localStorage.getItem('simulator_roof') == null) {
				location.href = '/fr/simulateur';
			}

			var roof = JSON.parse(localStorage.getItem('simulator_roof'));
			var src = $('#form-simulator .illu img').attr('src');

			$('#form-simulator .illu img').attr('src', src.replace(/(0|15|30|45)/, roof.roof));

			if (localStorage.getItem('simulator_orientation') !== null) {
				var simulator_orientation = JSON.parse(localStorage.getItem('simulator_orientation'));

				$('#form-simulator .illu img').attr('src', src.replace(/(0|15|30|45)/, roof.roof).replace(/(-o|-so|-s|-se|-e)/, '-'+simulator_orientation.orientation));

				$('#simulator-orientation .btn').removeClass('active');
				$('#simulator-orientation .btn[id='+simulator_orientation.orientation+']').addClass('active');
			}

			// orientation
			$(document).on('click', '#simulator-orientation .btn', function(e) {
				var orientation = $(this).attr('id');
				$('#simulator-orientation .btn').removeClass('active');
				$(this).addClass('active');

				$('#form-simulator .illu img').attr('src', src.replace(/(0|15|30|45)/, roof.roof).replace(/(-o|-so|-s|-se|-e)/, '-'+orientation));
				const orientation_json = {
				    orientation: orientation
				}

				localStorage.setItem('simulator_orientation', JSON.stringify(orientation_json));
			});

			$(document).on('click', '#form-simulator .btn.btn-primary', function(e) {
				var ref = $('#simulator-orientation .active').attr('id');
				const orientation = {
				    orientation: ref
				}


				localStorage.setItem('simulator_orientation', JSON.stringify(orientation));
			})


		}


		// conso
		if($('#simulator-conso').length > 0) {
			// init 
			if (localStorage.getItem('simulator_map') == null) {
				location.href = '/fr/simulateur';
			}

			var roof = JSON.parse(localStorage.getItem('simulator_roof'));
			if (localStorage.getItem('simulator_conso') !== null) {
				var sim_conso = JSON.parse(localStorage.getItem('simulator_conso'));
				$('#conso').val(sim_conso.conso);
			}
			var src = $('#form-simulator .illu img').attr('src');

			$('#form-simulator .illu img').attr('src', src.replace(/(0|15|30|45)/, roof.roof));

			$(document).on('click', '#conso', function() {
				$('#conso').removeClass('input__field--error');
			});

			$(document).on('click', '#help-conso .btn', function(e) {
				var help_conso = $(this).attr('id');
				$('#conso').val(help_conso);
				$('#help-conso').removeClass('show');
				
			});

			$(document).on('click', '#form-simulator .btn.btn-primary', function(e) {
				var ref = $('#conso').val();

				if(ref == '' || ref == 0) {
					e.preventDefault();
					$('#conso').addClass('input__field--error');
				}
				else {
					const conso = {
					    conso: ref
					}

					localStorage.setItem('simulator_conso', JSON.stringify(conso));
				}
			})
		}
	}*/



	// simulator 2

	if($('#form-simulator').length > 0) {
		// addresse

		if($('#form-simulator #full-address').length > 0) {
			// init 

			if (localStorage.getItem('simulator_address') !== null) {
				var simulator_address = JSON.parse(localStorage.getItem('simulator_address'));

				$('#house-mask').attr("fill-opacity", 1).delay(3000).attr("fill-opacity", 0);
				$('#form-simulator #full-address').val(simulator_address.location);
			}

			$(document).on('click', '#form-simulator .btn.btn-primary', function(e) {
				var simulator_address = JSON.parse(localStorage.getItem('simulator_address'));

				var check = false;
				for (var i in simulator_address.address) {
					var component = simulator_address.address[i];
					
					
					if(component.types[0] == 'street_number') {
						check = true;
					}
				}

				if(check == false) {
					e.preventDefault();
					localStorage.removeItem('simulator_address');
					$('#error-msg').html('Veuillez indiquer un numéro de rue');
					$('#error-msg').removeClass('d-none');				
					$('#full-address').addClass('input__field--error');
				}
			})
		}

		// roof
		if($('#simulator-roof').length > 0) {
			// init 
			if (localStorage.getItem('simulator_address') == null) {
				location.href = '/fr/simulateur';
			}

			if (localStorage.getItem('simulator_roof') !== null) {
				var simulator_roof = JSON.parse(localStorage.getItem('simulator_roof'));

				$('#form-simulator .roof').hide();
				$('#form-simulator #roof-'+simulator_roof.roof).show();

				$('#simulator-roof .btn').removeClass('active');
				$('#simulator-roof .btn[id='+simulator_roof.roof+']').addClass('active');
			}

			// roof
			$(document).on('click', '#simulator-roof .btn', function(e) {
				var inclinaison = $(this).attr('id');

				$('#simulator-roof .btn').removeClass('active');
				$(this).addClass('active');

				$('#form-simulator .roof').fadeOut(1001);
				$('#form-simulator #roof-'+inclinaison).fadeIn(1000);
				
				const roof = {
				    roof: inclinaison
				}

				localStorage.setItem('simulator_roof', JSON.stringify(roof));
			});

			$(document).on('click', '#form-simulator .btn.btn-primary', function(e) {
				var inclinaison = $('#simulator-roof .active').attr('id');
				const roof = {
				    roof: inclinaison
				}

				localStorage.setItem('simulator_roof', JSON.stringify(roof));
			})
		}

		// orientation
		if($('#simulator-orientation').length > 0) {

			// init 
			if (localStorage.getItem('simulator_roof') == null) {
				location.href = '/fr/simulateur';
			}

			var roof = JSON.parse(localStorage.getItem('simulator_roof'));
			var src = $('#form-simulator .illu img').attr('src');

			if (localStorage.getItem('simulator_roof') !== null) {
				var simulator_roof = JSON.parse(localStorage.getItem('simulator_roof'));
				
				$('#form-simulator .roof').hide();
				$('#form-simulator #roof-'+simulator_roof.roof).show();
			}

			if (localStorage.getItem('simulator_orientation') !== null) {
				var simulator_orientation = JSON.parse(localStorage.getItem('simulator_orientation'));
				
				$('#form-simulator .arrow').hide();
				$('#form-simulator #orientation').delay(1500).fadeIn();	
				$('#form-simulator #orientation #'+simulator_orientation.orientation).delay(1500).fadeIn();

				$('#simulator-orientation .btn').removeClass('active');
				$('#simulator-orientation .btn[id='+simulator_orientation.orientation+']').addClass('active');
			}
			else {		
				$('#form-simulator .arrow').hide();	
				$('#form-simulator #orientation').delay(1500).fadeIn();	
				$('#form-simulator #orientation #S').delay(1500).fadeIn();
			}

			// orientation
			$(document).on('click', '#simulator-orientation .btn', function(e) {
				var orientation = $(this).attr('id');
				
				$('#form-simulator .arrow').fadeOut(250);
				$('#form-simulator #orientation #'+orientation).fadeIn();

				$('#simulator-orientation .btn').removeClass('active');
				$(this).addClass('active');

				const orientation_json = {
				    orientation: orientation
				}

				localStorage.setItem('simulator_orientation', JSON.stringify(orientation_json));
			});

			$(document).on('click', '#form-simulator .btn.btn-primary', function(e) {
				var ref = $('#simulator-orientation .active').attr('id');
				const orientation = {
				    orientation: ref
				}


				localStorage.setItem('simulator_orientation', JSON.stringify(orientation));
			})


		}

		// conso
		if($('#simulator-conso').length > 0) {
			function light_opacity(conso) {
				var light = $('.windows').attr("fill-opacity");

				var light_opacity = conso / 5000;

				if(light_opacity > 1) {
					light_opacity = 1;
				}

				console.log(light_opacity)

				$('.windows').attr("fill-opacity",light_opacity);
			}

			// init 
			if (localStorage.getItem('simulator_map') == null) {
				location.href = '/fr/simulateur';
			}

			if (localStorage.getItem('simulator_roof') !== null) {
				var simulator_roof = JSON.parse(localStorage.getItem('simulator_roof'));
				
				$('#form-simulator .roof').hide();
				$('#form-simulator #roof-'+simulator_roof.roof).show();
			}

			light_opacity(0);

			if (localStorage.getItem('simulator_conso') !== null) {
				var sim_conso = JSON.parse(localStorage.getItem('simulator_conso'));
				$('#conso').val(sim_conso.conso);

				light_opacity(sim_conso.conso);
			}

			$(document).on('click', '#conso', function() {
				$('#conso').removeClass('input__field--error');
			});

			$(document).on('click', '#help-conso .btn', function(e) {
				var help_conso = $(this).attr('id');
				$('#conso').val(help_conso);
				$('#help-conso').removeClass('show');

				light_opacity(help_conso);

				if(help_conso == '' || help_conso == 0) {
					e.preventDefault();
					$('#conso').addClass('input__field--error');
				}
				else {
					const conso = {
					    conso: help_conso
					}

					localStorage.setItem('simulator_conso', JSON.stringify(conso));
				}
				
			});

			$(document).on('change', '#conso', function(e) {
				e.preventDefault();

				var sel_conso = $('#conso').val();
				light_opacity(sel_conso);

				if(sel_conso == '' || sel_conso == 0) {
					e.preventDefault();
					$('#conso').addClass('input__field--error');
				}
				else {
					const conso = {
					    conso: sel_conso
					}

					localStorage.setItem('simulator_conso', JSON.stringify(conso));
				}
			});

			$(document).on('click', '#form-simulator .btn.btn-primary', function(e) {
				var sel_conso = $('#conso').val();

				if(sel_conso == '' || sel_conso == 0) {
					e.preventDefault();
					$('#conso').addClass('input__field--error');
				}
				else {
					const conso = {
					    conso: sel_conso
					}

					localStorage.setItem('simulator_conso', JSON.stringify(conso));
				}
			});
		}

		// battery
		if($('#simulator-battery').length > 0) {

			// init 
			if (localStorage.getItem('simulator_conso') == null) {
				location.href = '/fr/simulateur';
			}

			if (localStorage.getItem('simulator_roof') !== null) {
				var simulator_roof = JSON.parse(localStorage.getItem('simulator_roof'));
				
				$('#form-simulator .roof').hide();
				$('#form-simulator #roof-'+simulator_roof.roof).show();
			}


			$('#form-simulator .panel').hide().delay(1500).fadeIn();
			$('#form-simulator #battery').hide();

			if (localStorage.getItem('simulator_battery') !== null) {
				var simulator_battery = JSON.parse(localStorage.getItem('simulator_battery'));
				
				if(simulator_battery.battery == 'battery') {
					$('#battery, .battery').hide().delay(1500).fadeIn();
				}
				else {
					$('#battery, .battery').fadeOut();					
				}

				$('#simulator-battery .btn').removeClass('active');
				$('#simulator-battery .btn[id='+simulator_battery.battery+']').addClass('active');
			}


			// battery
			$(document).on('click', '#simulator-battery .btn', function(e) {
				var battery = $(this).attr('id');
				
				if(battery == 'battery') {
					$('#battery, .battery').fadeIn();
				}
				else {
					$('#battery, .battery').fadeOut();					
				}

				$('#simulator-battery .btn').removeClass('active');
				$(this).addClass('active');

				const battery_json = {
				    battery: battery
				}

				localStorage.setItem('simulator_battery', JSON.stringify(battery_json));
			});

			$(document).on('click', '#form-simulator .btn.btn-primary', function(e) {
				var ref = $('#simulator-battery .active').attr('id');
				const battery = {
				    battery: ref
				}

				localStorage.setItem('simulator_battery', JSON.stringify(battery));
			})


		}


		// charger
		if($('#simulator-charger').length > 0) {

			// init 
			if (localStorage.getItem('simulator_battery') == null) {
				location.href = '/fr/simulateur';
			}

			if (localStorage.getItem('simulator_roof') !== null) {
				var simulator_roof = JSON.parse(localStorage.getItem('simulator_roof'));
				
				$('#form-simulator .roof').hide();
				$('#form-simulator #roof-'+simulator_roof.roof).show();
			}


			$('#form-simulator .panel').hide().delay(1500).fadeIn();
			$('#form-simulator #car').hide();

			if (localStorage.getItem('simulator_charger') !== null) {
				var simulator_charger = JSON.parse(localStorage.getItem('simulator_charger'));
				
				if(simulator_charger.charger == 'charger') {
					$('#car, .charger').hide().delay(1500).fadeIn();
				}
				else {
					$('#car, .charger').fadeOut();					
				}

				$('#simulator-charger .btn').removeClass('active');
				$('#simulator-charger .btn[id='+simulator_charger.charger+']').addClass('active');
			}

			// charger
			$(document).on('click', '#simulator-charger .btn', function(e) {
				var charger = $(this).attr('id');
				$('#simulator-charger .btn').removeClass('active');
				$(this).addClass('active');
				
				if(charger == 'charger') {
					$('#car, .charger').fadeIn();
				}
				else {
					$('#car, .charger').fadeOut();					
				}

				const charger_json = {
				    charger: charger
				}

				localStorage.setItem('simulator_charger', JSON.stringify(charger_json));
			});

			$(document).on('click', '#form-simulator .btn.btn-primary', function(e) {
				var ref = $('#simulator-charger .active').attr('id');
				const charger = {
				    charger: ref
				}


				localStorage.setItem('simulator_charger', JSON.stringify(charger));
			})


		}
	}

	if ($('.three-item-carousel').length) {
		var map_carousel = $('.three-item-carousel').owlCarousel({
			loop:true,
			margin:30,
			nav:true,
			smartSpeed: 500,
			autoplay: false,
			navText: [ '<span class="fas fa-angle-left"></span>', '<span class="fas fa-angle-right"></span>' ],
			items: 1
		});		

		$(document).on('click', '.gmnoprint div:nth-child(2) button', function() {
		    map_carousel.trigger('to.owl.carousel', [1, 1000])
	  	});	

	  	$(document).on('click', '.gmnoprint div:first button', function() {
		    map_carousel.trigger('to.owl.carousel', [2, 1000])
	  	});	
	}


	// formulaire de contact
	$(document).on('submit', '#form-contact', function(e) {	
		var data = $(this).find('input, textarea, select').filter(':visible, input[type=hidden]').serializeArray();

		$.getJSON(path+'Connections/request/xhr/contact/send-contact.php', data, function(response) {
			if(response.action == 'success') {

				// toastr.success(response.msg);
				$('#alert').html('<div class="alert alert-success" role="alert">Message successfully sent !</div>');
				$('input, textarea, select').each(function(){
				    $(this).val('');
				    $('input[type=checkbox]').prop('checked', false);
				});
				
			}
			else if(response.action == 'empty') {
				// toastr.warning(response.msg);
			}
			else {
				// toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// update des données du user
	$(document).on('submit', '#form-user-data', function(e) {
		var data = $(this).serializeArray();

		$.getJSON(path+'Connections/request/xhr/membre/update-user-data.php', data, function(response) {
			if(response.action == 'success') {
				// toastr.success(response.msg);
			}
			else if(response.action == 'empty') {
				// toastr.warning(response.msg);
			}
			else {
				// toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// recovery du mot de passe
	$(document).on('submit', '#form-recovery', function(e) {
		var data = $(this).serializeArray();

		$.getJSON(path+'Connections/request/xhr/membre/recovery.php', data, function(response) {
			if(response.action == 'success') {
				// toastr.success(response.msg);
				//location.href = response.url;
			}
			else if(response.action == 'empty') {
				// toastr.warning(response.msg);
			}
			else {
				// toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	$(document).on('keyup', '#form-new-account input[name=password]', function() {
		var password = $('#form-new-account input[name=password]').val();
		check_pw('#form-new-account input[name=password]');			
	});

	$(document).on('keyup', '#form-update-password input[name=password], #form-update-password input[name=repassword]', function() {
		var password = $('#form-update-password input[name=password]').val();
		var repassword = $('#form-update-password input[name=repassword]').val();
		check_pw('#form-update-password input[name=password]');

		if($(this).closest('form').hasClass('valid') && password == repassword) {
			$(this).closest('form').find('input[type=submit]').prop('disabled', false);
		}
		else {
			$(this).closest('form').find('input[type=submit]').prop('disabled', true);
		}
			
	});

	$(document).on('keyup', '#form-password input[name=password], #form-password input[name=repassword]', function() {
		var password = $('#form-password input[name=password]').val();
		var repassword = $('#form-password input[name=repassword]').val();
		check_pw('#form-password input[name=password]');

		if($(this).closest('form').hasClass('valid') && password == repassword) {
			$(this).closest('form').find('input[type=submit]').prop('disabled', false);
		}
		else {
			$(this).closest('form').find('input[type=submit]').prop('disabled', true);
		}
			
	});

	// recovery du mot de passe
	$(document).on('submit', '#form-password', function(e) {
		var data = $(this).serializeArray();

		$.getJSON(path+'Connections/request/xhr/membre/password.php', data, function(response) {
			if(response.action == 'success') {
				// toastr.success(response.msg);
				location.href = response.url;
			}
			else if(response.action == 'empty') {
				// toastr.warning(response.msg);
			}
			else {
				// toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// modification du mot de passe
	$(document).on('submit', '#form-update-password', function(e) {
		var data = $(this).serializeArray();

		$.getJSON(path+'Connections/request/xhr/membre/update-password.php', data, function(response) {
			if(response.action == 'success') {
				// toastr.success(response.msg);

				$('input[type=password]').each(function(){
				    $(this).val('');
				});

				$('ul.list-styled li').removeClass('valid-regex');
			}
			else if(response.action == 'empty') {
				// toastr.warning(response.msg);
			}
			else {
				// toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// init tooltip BS
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

    // slider témoignages
	if($('.slider-temoignages').length > 0) {
	    $('.slider-temoignages').slick({
	        infinite: true,
	        slidesToShow: 2,
	        slidesToScroll: 2,
	        dots:true,
	        arrows:false,
	        responsive: [
	        {
	            breakpoint: 480,
	            settings: {
	                slidesToShow: 1,
	                slidesToScroll: 1
	            }
	        }
	        ]
	    });
	}

    if($('#g-recaptcha-response').length > 0) {
    	
		function recaptcha()
		{
			 grecaptcha.ready(function() {
				grecaptcha.execute('6LfoEXYgAAAAAFvaOjif9bhRirfKKxvHhRsFmhUe', {action: 'send_form'})
				.then(function(token) {
					var recaptchaResponse = document.getElementById('g-recaptcha-response');
                	recaptchaResponse.value = token;
					
				})
			});
		}

    	recaptcha();
    	
		var intervalID = setInterval(recaptcha, 110*1000);
    }

    // slider témoignages
    if($('.slider-cours').length > 0) {
	    $('.slider-cours').slick({
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        dots:true,
	        arrows:false,
	        responsive: [
	        {
	            breakpoint: 480,
	            settings: {
	                slidesToShow: 1,
	                slidesToScroll: 1
	            }
	        }
	        ]
	    });
	}

    // CASE INSENSITIVE FUNCTION.
	jQuery.expr[':'].contains = function(a, i, m) {
    var rExps=[
        {re: /[\xC0-\xC6]/g, ch: "A"},
        {re: /[\xE0-\xE6]/g, ch: "a"},
        {re: /[\xC8-\xCB]/g, ch: "E"},
        {re: /[\xE8-\xEB]/g, ch: "e"},
        {re: /[\xCC-\xCF]/g, ch: "I"},
        {re: /[\xEC-\xEF]/g, ch: "i"},
        {re: /[\xD2-\xD6]/g, ch: "O"},
        {re: /[\xF2-\xF6]/g, ch: "o"},
        {re: /[\xD9-\xDC]/g, ch: "U"},
        {re: /[\xF9-\xFC]/g, ch: "u"},
        {re: /[\xC7-\xE7]/g, ch: "c"},
        {re: /[\xD1]/g, ch: "N"},
        {re: /[\xF1]/g, ch: "n"}
    ];

    var element = $(a).text();
    var search  = m[3];

    $.each(rExps, function() {
         element    = element.replace(this.re, this.ch);
         search     = search.replace(this.re, this.ch);
    });

    return element.toUpperCase()
        .indexOf(search.toUpperCase()) >= 0;
    };



			$(".gmnoprint").each(function(){
			    // ID the Hand button
			    newObj = $(this).find('div:first button');
			    newObj.attr('id', 'btnHand');

			    // ID the Marker button
			    newObj = $(this).find('div:nth-child(2) button');
			    newObj.attr('id', 'btnPolygon');

			});
});

function check_pw(password) {
	var $this = $(password);
	var pw = $this.val();
	var test = true;
	// At least one LOWERCASE character:
	var lowerCasePattern = /^(?=.*[a-z]).+$/;

	if(lowerCasePattern.test(pw)) {		    
		$('.lowercase').addClass('valid-regex');
	}
	else {
		$('.lowercase').removeClass('valid-regex');
		test = false;
	}

    // At least one UPPERCASE character:
    var upperCasePattern = /^(?=.*[A-Z]).+$/;
    
    if(upperCasePattern.test(pw)) {		    
    	$('.uppercase').addClass('valid-regex');
    }
    else {
    	$('.uppercase').removeClass('valid-regex');
    	test = false;
    }

    // At least one NUMBER:
    var numberPattern = /^(?=.*[\d]).+$/;
    
    if(numberPattern.test(pw)) {		    
    	$('.number').addClass('valid-regex');
    }
    else {
    	$('.number').removeClass('valid-regex');
    	test = false;
    }

    // At least one SPECIAL character:
    var specialCharacterPattern = /([-+=_!@#$%^&*.,;:'\"<>/?`~\[\]\(\)\{\}\\\|\s])/;

    if(specialCharacterPattern.test(pw)) {		    
    	$('.specialcase').addClass('valid-regex');
    }
    else {
    	$('.specialcase').removeClass('valid-regex');
    	test = false;
    }

    // At least 8 characters in the screen:
    var characterCountPattern = /^.{8,}/;

    if(characterCountPattern.test(pw)) {		    
    	$('.minimumcase').addClass('valid-regex');
    }
    else {
    	$('.minimumcase').removeClass('valid-regex');
    	test = false;
    }

    if($('.not-secure li').length == $('.valid-regex').length) {
    	$this.closest('form').addClass('valid');
    }
    else {
    	$this.closest('form').removeClass('valid');
    }
}



// address
if($('#full-address').length) {
	// Google place API - autcomplete adresse
	/*function initMap() {
		
	}*/

	function onPlaceChanged() {

		var place = this.getPlace();

		const address = {
		    address: place.address_components,
		    location: place.formatted_address,
		    geometry: place.geometry,
		}

		localStorage.setItem('simulator_address', JSON.stringify(address));

		var simulator_address = JSON.parse(localStorage.getItem('simulator_address'));

		var check = false;
		for (var i in simulator_address.address) {
			var component = simulator_address.address[i];
			
			
			if(component.types[0] == 'street_number') {
				check = true;
			}
		}

		if(check == false) {
			$('#error-msg').html('Veuillez indiquer un numéro de rue');
			$('#error-msg').removeClass('d-none');				
			$('#full-address').addClass('input__field--error');
		}
		else {			
			$('#error-msg').addClass('d-none');				
			$('#full-address').removeClass('input__field--error');
			if($('#house-mask').length > 0) {
				$('#house-mask').attr("fill-opacity", 1).delay(3000).attr("fill-opacity", 0);
			}
		}

	    localStorage.removeItem('simulator_map');
    	localStorage.removeItem('simulator_area');
    	localStorage.removeItem('simulator_orientation');
    	localStorage.removeItem('simulator_roof');
    	localStorage.removeItem('simulator_conso');

		/*var $this = $(this).closest('form');
		xhr_send(path, token, $this);*/
		
	}

	/*google.maps.event.addDomListener(window, 'load', function() {
		initializeAutocomplete('full-address');
	});*/
}
else if($('#simulator-map').length) {

	// init
	if (localStorage.getItem('simulator_orientation') == null) {
		location.href = '/fr/simulateur';
	}

	$(document).on('click', '#form-simulator .btn.btn-primary', function(e) {
		e.preventDefault();
		var href = $(this).attr('href');

		if (localStorage.getItem('simulator_map') == null) {
			// toastr.warning('Veuillez suivre les instructions en délémitant la surface de votre toiture');
		}
		else {
			location.href = href;
		}
	})

	var address = JSON.parse(localStorage.getItem('simulator_address'));
	var roof = JSON.parse(localStorage.getItem('simulator_roof'));
	var map_coord = JSON.parse(localStorage.getItem('simulator_map'));
	var orientation = JSON.parse(localStorage.getItem('simulator_orientation'));

	var translate_orientation = {o: 'Ouest', so : 'Sud-Ouest', s: 'Sud', se: 'Sud-Est', e: 'Est'};

	$('#orientation').html(translate_orientation[orientation.orientation]);

	function panelArea(hypotenuse, angle) {
		// Convert angle to radians
		let angleRad = angle * (Math.PI / 180);
		// Calculate side length
		let sideLength = Math.sqrt(Math.pow(hypotenuse, 2) - Math.pow(hypotenuse * Math.sin(angleRad), 2));
		// Return side length
		return sideLength;
	}

	function getCoordinates(polygon) {
		// Initialize an empty array to store the polygon's coordinates
		let polygonCoords = [];
		// Get the polygon's paths and loop through them
		polygon.getPaths().forEach(function(path) {
			// Initialize an empty array to store the path's coordinates

			// Loop through the path's coordinates and add them to the array
			path.forEach(function(coord) {
				polygonCoords.push({lat: coord.lat(), lng: coord.lng()});
			});
		});

		// Return the polygon's coordinates
		return polygonCoords;
	}



	/*function initMap() {
		
			
  	}*/


		/*google.maps.event.addDomListener(window, 'load', function() {
			initMap();
		});*/
}
else if($('#full-address').length && $('#simulator-map').length){
	
}

function initMap() {
	// full address
	if($('#full-address').length) {
		$('.copyright').after('<span>1</span>');
		var element = document.getElementById('full-address');

		var options = {
			//types: ['(cities)']
			types: ['geocode'],
			componentRestrictions: {country: ["be"]}
		};

		if (element) {
			var autocomplete = new google.maps.places.Autocomplete(element, options);
			google.maps.event.addListener(autocomplete, 'place_changed', onPlaceChanged);
		}
	}
	// simulator map
	else if($('#simulator-map').length) {
		$('.copyright').after('<span>2</span>');
	    // The location of Uluru
	    var center = {lat: address.geometry.location.lat, lng: address.geometry.location.lng};
	    // The map, centered at Uluru
	    var map = new google.maps.Map(
	        document.getElementById('simulator-map'), 
	        {
        		zoom: 20, 
        		center: center, 
        		mapTypeId: "hybrid", 
        		draggableCursor: 'default',
      			streetViewControl: false, 
    			zoomControl: true,     			
  				mapTypeControl: false
        	});

	    	if (localStorage.getItem('simulator_map') !== null) {
				let triangleCoords = map_coord;

				// Construct the polygon.
				var bermudaTriangle = new google.maps.Polygon({
					paths: triangleCoords,
					strokeColor: "#8dd00e",
					strokeOpacity: 0.8,
					strokeWeight: 2,
					fillColor: "#8dd00e",
					fillOpacity: 0.35,
					editable: false,
					draggable: true,	
				});

				bermudaTriangle.setMap(map);
			}

		    // The drawing manager
		    var drawingManager = new google.maps.drawing.DrawingManager({
				drawingMode: google.maps.drawing.OverlayType.POLYGON,
				drawingControl: true,
				drawingControlOptions: {
			        position: google.maps.ControlPosition.TOP_CENTER,
			        drawingModes: ['polygon']
	      		},
	      		polygonOptions: {
			        editable: true,
			        draggable: true,						
			        strokeColor: "#8dd00e",
			        strokeOpacity: 0.8,
			        strokeWeight: 2,
			        fillColor: "#8dd00e",
			        fillOpacity: 0.5,
			        zIndex: -1
	      		},
	     		markerOptions: {
			        draggable: true
		    	},
	   		});

	    	drawingManager.setMap(map);

	    	 // Create the DIV to hold the control and call the CustomControl() constructor passing in this DIV.
		    var customControlDiv = document.createElement('div');
		    var customControl = new CustomControl(customControlDiv, map);

		    customControlDiv.index = 1;
		    map.controls[google.maps.ControlPosition.TOP_CENTER].push(customControlDiv);

		    function CustomControl(controlDiv, map) {

			    // Set CSS for the control border
			    var controlUI = document.createElement('div');
			    controlUI.title = 'Recommencer';
			    controlUI.classList.add("maps-delete-button");
			    controlDiv.appendChild(controlUI);

			    // Set CSS for the control interior
			    var controlText = document.createElement('div');
			    controlText.innerHTML = '<i class="fa-light fa-trash fa-xl"></i>';
			    controlUI.appendChild(controlText);

			    // Setup the click event listeners
			    controlUI.addEventListener('click', () => {
				    localStorage.removeItem('simulator_map');
			    	localStorage.removeItem('simulator_area');
			    	location.reload();
			  	});
			}

			console.log($('.gmnoprint div:first img'));
			$('.gmnoprint div:first img').parent().html('<i class="fa-light fa-hand fa-xl"></i>');
			// $('.gmnoprint div:nth-child(2) button').html('<i class="fa-light fa-hand fa-xl"></i>');


		    //Calculate surface area
		    google.maps.event.addListener(drawingManager, 'polygoncomplete', function (polygon) {
		    	var map_carousel = $('.three-item-carousel').owlCarousel({
					loop:true,
					margin:30,
					nav:true,
					smartSpeed: 500,
					autoplay: false,
					navText: [ '<span class="fas fa-angle-left"></span>', '<span class="fas fa-angle-right"></span>' ],
					items: 1
				});

		    	map_carousel.trigger('to.owl.carousel', [2, 1000])
				// Calculate the area
				let area = google.maps.geometry.spherical.computeArea(polygon.getPath());
				// document.getElementById('area').innerHTML = parseFloat(area).toFixed(2) + " m<sup>2</sup>";

				// TRINA SOLAR 415 FULL BLACK THIRD CUT 
				let rectangleArea = panelArea(1.762, roof.roof) * 1.134;


			    // Finally calculate and return the number of rectangles that fit in the polygon

			    let panelQuantity = Math.floor(area / rectangleArea);
			    console.log(area, rectangleArea, panelQuantity);
	      		// document.getElementById('panel').innerHTML = parseFloat(panelQuantity).toFixed(2) + " panels";

	      		console.log( getCoordinates(polygon))
	      		localStorage.setItem('simulator_map', JSON.stringify(getCoordinates(polygon)));
	      		localStorage.setItem('simulator_area', JSON.stringify(area));

			    //Recalculate surface area
			    google.maps.event.addListener(polygon.getPath(), 'set_at', function () {
		        	// Calculate the area
		        	let area = google.maps.geometry.spherical.computeArea(polygon.getPath());
		        	// document.getElementById('area').innerHTML = parseFloat(area).toFixed(2) + " m<sup>2</sup>";

	        		// TRINA SOLAR 415 FULL BLACK THIRD CUT 
	      			let rectangleArea = panelArea(1.762, roof.roof) * 1.134;

				    // Finally calculate and return the number of rectangles that fit in the polygon
				    let panelQuantity = Math.floor(area / rectangleArea);

	        		// document.getElementById('panel').innerHTML = parseFloat(panelQuantity).toFixed(2) + " panels";

	        		console.log(getCoordinates(polygon))
	      			localStorage.setItem('simulator_map', JSON.stringify(getCoordinates(polygon)));
	      			localStorage.setItem('simulator_area', JSON.stringify(area));
	      		});
	    	}
	    );


    	$('#delete-button').on('click', function(e) {
    		e.preventDefault();

	    	localStorage.removeItem("simulator_map");
	    	localStorage.removeItem("simulator_area");
	    	location.reload();
		});
	}
}